import { render, staticRenderFns } from "./new-promotion.vue?vue&type=template&id=1832abee&scoped=true"
import script from "./new-promotion.vue?vue&type=script&lang=js"
export * from "./new-promotion.vue?vue&type=script&lang=js"
import style0 from "./new-promotion.vue?vue&type=style&index=0&id=1832abee&prod&lang=scss&scoped=true"
import style1 from "./new-promotion.vue?vue&type=style&index=1&id=1832abee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1832abee",
  null
  
)

export default component.exports